import { useState } from "react";
import { Menu } from "@headlessui/react";
import { FaChevronDown, FaExternalLinkAlt } from "react-icons/fa";
 
const themes = [
  { id: 1, name: "Theme 1", url: "https://theme1.astechsolutions.co" },
  { id: 2, name: "Theme 2", url: "https://theme2.astechsolutions.co" },
  { id: 3, name: "Theme 3", url: "https://theme3.astechsolutions.co" },
  { id: 4, name: "Theme 4", url: "https://theme4.astechsolutions.co" },
];
 
export default function ThemeDropdown() {
  const [selected, setSelected] = useState(null);
 
  return (
    <div className="relative inline-block text-left">
      <Menu>
        <Menu.Button className="inline-flex items-center justify-between w-56 px-4 py-3 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-xl shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 transition-all">
          {selected ? selected.name : "Select Theme"}
          <FaChevronDown className="w-4 h-4 ml-2 text-gray-500" />
        </Menu.Button>
 
        <Menu.Items className="absolute right-0 z-50 mt-2 w-60 origin-top-right bg-white divide-y divide-gray-100 rounded-xl shadow-xl ring-1 ring-black ring-opacity-5 focus:outline-none animate-fadeIn">
          {themes.map((theme) => (
            <Menu.Item key={theme.id}>
              {({ active }) => (
                <button
                  onClick={() => {
                    setSelected(theme);
                    window.open(theme.url, "_blank"); // open in new tab
                  }}
                  className={`${
                    active ? "bg-indigo-50 text-indigo-600" : "text-gray-700"
                  } flex items-center justify-between w-full px-4 py-3 text-sm font-medium rounded-lg transition`}
                >
                  <span>{theme.name}</span>
                  <FaExternalLinkAlt className="w-4 h-4" />
                </button>
              )}
            </Menu.Item>
          ))}
        </Menu.Items>
      </Menu>
    </div>
  );
}